module.exports = __webpack_public_path__ + "static/media/test-elementary.7ca3231c.png";